export default __webpack_public_path__ + "static/media/team20.7d35b554.JPG";